import React from 'react';
import { User, Settings, LogOut } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useUserProfile } from '@/hooks/useUserProfile';

interface V11UserDropdownProps {
  userName?: string;
  userEmail?: string;
  isOpen: boolean;
  onClose: () => void;
  onLogout: () => void;
  placement?: 'bottom' | 'top' | 'right';
}

export const V11UserDropdown: React.FC<V11UserDropdownProps> = ({
  userName: propUserName,
  userEmail: propUserEmail,
  isOpen,
  onClose,
  onLogout,
  placement = 'bottom',
}) => {
  const { userData } = useUserProfile();

  const userName = propUserName || userData.name;
  const userEmail = propUserEmail || userData.email;

  if (!isOpen) return null;

  const handleLogout = () => {
    onLogout();
    onClose();
  };

  const getDropdownClasses = () => {
    const baseClasses =
      'fixed w-64 z-[60] rounded-xl border border-v11-border bg-v11-bg-secondary shadow-2xl backdrop-blur-sm';

    switch (placement) {
      case 'top':
        return `${baseClasses} bottom-20 left-4`;
      case 'right':
        return `${baseClasses} left-60 bottom-4`;
      case 'bottom':
      default:
        return `${baseClasses} right-0 top-full mt-2`;
    }
  };

  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose} />

      <div className={getDropdownClasses()}>
        <div className="border-b border-v11-border px-4 py-3">
          <p className="text-sm font-medium text-v11-text-primary truncate">{userName}</p>
          {userEmail && <p className="text-xs text-v11-text-muted truncate">{userEmail}</p>}
        </div>

        <div className="py-2">
          <Link
            to="/v11/profile"
            className="flex items-center gap-3 px-4 py-2 text-sm text-v11-text-secondary hover:bg-v11-surface-hover hover:text-v11-text-primary transition"
            onClick={onClose}
          >
            <User className="h-4 w-4" />
            View Profile
          </Link>

          <Link
            to="/v11/settings"
            className="flex items-center gap-3 px-4 py-2 text-sm text-v11-text-secondary hover:bg-v11-surface-hover hover:text-v11-text-primary transition"
            onClick={onClose}
          >
            <Settings className="h-4 w-4" />
            Account Settings
          </Link>
        </div>

        <div className="border-t border-v11-border py-2">
          <button
            onClick={handleLogout}
            className="flex w-full items-center gap-3 px-4 py-2 text-sm text-red-400 hover:bg-v11-surface-hover hover:text-red-300 transition"
          >
            <LogOut className="h-4 w-4" />
            Sign Out
          </button>
        </div>
      </div>
    </>
  );
};
